"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = void 0;
const rxjs_1 = require("rxjs");
const errorCallback = () => rxjs_1.EMPTY;
const validate = (payload, schema, successCallback) => schema.decode(payload).fold(errorCallback, successCallback);
exports.validate = validate;
//# sourceMappingURL=utils.js.map